import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#1E1F25",
      light: "#2C2D33", 
      dark: "#141519",
      contrastText: "#ffffff",
    },

    secondary: {
      main: "#3F51B5",
      light: "#5C6BC0",
      dark: "#303F9F",
      contrastText: "#ffffff",
    },

    background: {
      default: "#ffffff",
      paper: "#f4f5f7",
    },

    text: {
      primary: "#1a1a1a",
      secondary: "#444950",
    },

    divider: "#d9dbe0",

    error: {
      main: "#D32F2F",
    },
    warning: {
      main: "#ED6C02",
    },
    info: {
      main: "#1976D2",
    },
    success: {
      main: "#2E7D32",
    },
  },

  typography: {
    fontFamily: `'Space Grotesk', 'Roboto Mono', 'Segoe UI', sans-serif`,
    fontSize: 15,
    h1: { fontSize: "2.8rem", fontWeight: 700 },
    h2: { fontSize: "2.2rem", fontWeight: 600 },
    h3: { fontSize: "1.8rem", fontWeight: 600 },
    h4: { fontSize: "1.5rem", fontWeight: 500 },
    h5: { fontSize: "1.3rem", fontWeight: 500 },
    h6: { fontSize: "1.1rem", fontWeight: 500 },
    button: { fontWeight: 600, textTransform: "none" },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: (theme) => theme.palette.error.main,
          },
        },
      },
    },
  },
});

export default theme;
